import{zip as r}from"../observable/zip.js";function o(){for(var o=[],t=0;t<arguments.length;t++)o[t]=arguments[t];return function(t){return t.lift.call(r.apply(void 0,[t].concat(o)))}}export{o as zip};
